/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewFindingResolutionItem
 */
export interface CRSFSecReviewFindingResolutionItem {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewFindingResolutionItem
     */
    action: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingResolutionItem
     */
    ts: number;
}

/**
 * Check if a given object implements the CRSFSecReviewFindingResolutionItem interface.
 */
export function instanceOfCRSFSecReviewFindingResolutionItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "ts" in value;

    return isInstance;
}

export function CRSFSecReviewFindingResolutionItemFromJSON(json: any): CRSFSecReviewFindingResolutionItem {
    return CRSFSecReviewFindingResolutionItemFromJSONTyped(json, false);
}

export function CRSFSecReviewFindingResolutionItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewFindingResolutionItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': json['action'],
        'ts': json['ts'],
    };
}

export function CRSFSecReviewFindingResolutionItemToJSON(value?: CRSFSecReviewFindingResolutionItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': value.action,
        'ts': value.ts,
    };
}

